import React from 'react';
import logger from "../../../../theme/src/shared/js/utils/logger.mjs";
import AppLoading from "../../../../theme/src/shared/js/AppLoading";
import * as defaultQuestionTypes from "../../../../theme/src/shared/js/components/questions/types/index.mjs";
import App from "./App";
import { initializeNeuroApplication } from "@ignitesales/neuro-application";
import messages from "./i18n/messages";
import {questionLayouts} from '../../../../theme/src/shared/js/components/questions/index.mjs';
import WebFont from "webfontloader";

const init = async () => {
  WebFont.load({
    typekit: {
      id: "daw8lwu",
    },
  });

  const icon = <i className="fa fa-exclamation-circle" alt="Error Exclamation Icon" />;

  await initializeNeuroApplication({
    AppComponent: App,
    LoadingComponent: AppLoading,
    messages,
    isBranchGuide: false,
    supportedLocales: ["en"],
    reducers: [],
    questionTypes: defaultQuestionTypes,
    questionLayouts: {
      ...questionLayouts,
      attributes: {
        error: {
          tag: 'div',
          position: 'afterSubtext',
          icon
        }
      }
    }
  });

  logger.info("Go for takeoff!");
};

init();
